const personSchema = ({
  name,
  jobTitle,
  description,
  image,
  url,
  sameAs = [],
}) => ({
  "@context": "https://schema.org",
  "@type": "Person",

  name,
  jobTitle,
  description,

  ...(image && {
    image: image,
  }),

  ...(url && {
    url: url,
  }),

  worksFor: {
    "@id": "https://irisimpulse.com/#organization",
  },

  ...(sameAs.length > 0 && {
    sameAs,
  }),
});

export default personSchema;
